
import { defineComponent } from 'vue';
import BaseIconTooltip from './BaseIconTooltip.vue';

export default defineComponent({
  name: 'BaseCard',

  components: {
    BaseIconTooltip
  },

  props: {
    title: {
      type: String,
      required: true
    },
    tooltipTrackingName: {
      type: String,
      required: false,
      default: ''
    },
    tooltipTrackingDescription: {
      type: String,
      required: false,
      default: ''
    }
  },

  computed: {
    hasInfo(): boolean {
      return !!this.$slots.info;
    },
    hasFooter(): boolean {
      return !!this.$slots.footer;
    }
  }
});
